module.exports = __webpack_public_path__ + "img/tg_02 (8).704226ec.jpg";